import React from 'react';
import { Card } from './ui/card';
import { CheckCircle, ArrowRight } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      title: 'Faites votre demande',
      description: 'Remplissez le formulaire en ligne avec vos besoins spécifiques',
      details: 'Indiquez la taille de benne, le type de déchets et votre localisation'
    },
    {
      number: '02',
      title: 'Recevez votre devis',
      description: 'Réponse sous 2 heures avec un tarif transparent',
      details: 'Prix tout compris : location, transport et traitement'
    },
    {
      number: '03',
      title: 'Validez et payez',
      description: 'Prépayez sur notre plateforme 100% sécurisée',
      details: 'Paiement sécurisé par carte bancaire'
    },
    {
      number: '04',
      title: 'Livraison rapide',
      description: 'Le transporteur livre la benne dans les délais',
      details: 'Livraison en 24h à votre adresse'
    }
  ];

  return (
    <section id="comment" className="py-20 bg-white scroll-mt-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comment ça marche ?
          </h2>
          <p className="text-xl text-gray-600">
            Un processus simple en 4 étapes pour votre location de benne
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-20 left-0 right-0 h-1 bg-gradient-to-r from-green-200 via-green-400 to-green-600" style={{ top: '80px' }}></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <Card className="p-6 h-full hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-green-200">
                  <div className="relative z-10">
                    <div className="mb-4">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-green-500 to-green-600 text-white text-2xl font-bold shadow-lg">
                        {step.number}
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-700 mb-3 font-medium">
                      {step.description}
                    </p>
                    <p className="text-sm text-gray-600">
                      {step.details}
                    </p>
                    <div className="mt-4 flex items-center text-green-600">
                      <CheckCircle className="h-5 w-5 mr-2" />
                      <span className="text-sm font-medium">Garanti</span>
                    </div>
                  </div>
                </Card>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-20 -right-4 z-20">
                    <ArrowRight className="h-8 w-8 text-green-600" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;